/**
 * Get a data attribute with css files to load on the header
 * @param {object} cssFiles - the data-css-files content
 */
function loadCssFiles(cssFiles) {
    const $head = $("head");
    cssFiles.forEach(cssFile => {
        const alreadyLoaded = $head.find("link")
            .toArray()
            .findIndex(link => link.rel === "stylesheet" && link.href === cssFile) > -1;

        if (!alreadyLoaded) {
            $head.append(`<link rel="stylesheet" type="text/css" href="${cssFile}" />`);
        }
    });
}

/**
 * Inits events to automatically load '.js-lazyload-template' elements, on client side.
 */
function initLazyLoad() {
    $(".js-lazyload-template").each(function () {
        const $this = $(this);
        const url = $this.data("url");

        $this.addClass("loading");
        $this.spinner().start();

        $.ajax({
            url: url,
            type: "GET",
            dataType: "html",
            success: function (data) {
                const $data = $(data);
                $this.html($data).promise().done(() => $this.trigger("lazyLoadTemplate:loaded", [$data]));
            },
            error: function (err) {
                $this.trigger("lazyLoadTemplate:error", [err]);
            },
            complete: function () {
                $this.spinner().stop();
                $this.removeClass("loading");
                $this.addClass("loaded");
            }
        });
    });
}

/**
 * Inits events to automatically load '.js-css-loader' elements, on client side, without spinner
 */
function initCssLoader() {
    $(".js-css-loader").each(function () {
        const $this = $(this);
        const cssFiles = $this.data("css-files") || [];
        loadCssFiles(cssFiles);
    });
}

module.exports = {
    initLazyLoad,
    initCssLoader
};
